export default "__VITE_ASSET__YgH6zaOS__"